export function BillingModel(guid: string): string {
	return `/v1/form-submissions/${guid}/billing-model`;
}

export function CancelFormSubmission(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/${ID}/cancel`;
}

export function Create(guid: string): string {
	return `/v1/form-submissions/${guid}/create`;
}

export function Create1(organizationID: number, guid: string): string {
	return `/v1/organizations/${organizationID}/form-submissions/${guid}/create`;
}

export function CreateModel(guid: string): string {
	return `/v1/form-submissions/${guid}/create-model`;
}

export function DeclineWaitlistInvite(guid: string): string {
	return `/v1/form-submissions/${guid}/waitlist/decline`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/${ID}`;
}

export function Export(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/export`;
}

export function GetPaymentStatus(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/${ID}/payment-status`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions`;
}

export function IndexView(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/form-submissions`;
}

export function InviteIndex(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/invites`;
}

export function InviteSelfIndex(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/invites/self`;
}

export function JoinWaitlist(guid: string): string {
	return `/v1/form-submissions/${guid}/waitlist`;
}

export function LeaveWaitlist(guid: string): string {
	return `/v1/form-submissions/${guid}/waitlist/leave`;
}

export function ListEligiblePackages(guid: string): string {
	return `/v1/form-submissions/${guid}/packages`;
}

export function ListIneligibleEventGroups(guid: string): string {
	return `/v1/form-submissions/${guid}/ineligible-event-groups`;
}

export function ListSelfConsents(): string {
	return `/v1/accounts/self/consents`;
}

export function ManagerIndexView(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/form-submissions/manager-index`;
}

export function ManagerShow(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/manager-show/${ID}`;
}

export function PreviewBillingModel(guid: string): string {
	return `/v1/form-submissions/${guid}/preview/billing-model`;
}

export function PreviewCreateModel(guid: string): string {
	return `/v1/form-submissions/${guid}/preview/create-model`;
}

export function PreviewListEligiblePackages(guid: string): string {
	return `/v1/form-submissions/${guid}/preview/packages`;
}

export function PublicCreate(guid: string): string {
	return `/v1/form-submissions/${guid}/public-create`;
}

export function PublicGetPaymentStatus(): string {
	return `/v1/form-submissions/public-payment-status`;
}

export function RejectInvite(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/${ID}/reject-invite`;
}

export function ResolveInvite(formInviteKey: string): string {
	return `/v1/form-submissions/invites/${formInviteKey}/resolve`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-submissions/${ID}`;
}

